import React from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import style from "../common.module.scss"
import LocationIconNew from '../../../shared/icons/LocationIconNew';
import { numberToFinanceFormat } from '../../../../utils';
import { CURRENCIES } from '../../../../mock';
import { MessageSquare } from 'lucide-react';
import AppTooltip from '../../../shared/AppTooltip/AppTooltip';

const OrdersInfoBasic = ({ item, onOpen, onOpenChat, isMarketplacePage = false, unreadCount = 0 }) => {
    const { t } = useTranslation();

    return (
        <div className={cn(style.basic_wrapper)}>
            <div className={style.basic_numbers}>
                <span className={style.basic_price}>{numberToFinanceFormat(item?.price)} {CURRENCIES[item?.currency || "KZT"]?.symbol || ""}</span>
                <div className={style.basic_lower_part}>
                    <span className={style.basic_number}> №{item?.number}</span>
                    {item?.referenceNumber && (
                        <>
                            <span
                                className={cn(style.basic_number, style.basic_reference)}
                                data-tooltip-id={`referenceNumber-tooltip-${item.id}`}
                            >
                                {" "}
                                - {item?.referenceNumber}
                            </span>

                            <AppTooltip id={`referenceNumber-tooltip-${item.id}`} positionStrategy="fixed" delayShow={50}>
                                №{item?.referenceNumber}
                            </AppTooltip>
                        </>
                    )}
                </div>
            </div>
                <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
                    <button className={style.basic_chat_btn} onClick={onOpenChat}>
                        <MessageSquare size={20} color="#FFFFFF" />
                        {t("orderInfo.ordersInfoBasic.chatButton")}
                        {unreadCount > 0 && (
                            <span className={style.basic_chat_badge}>{unreadCount}</span>
                        )}
                    </button>
                    {!isMarketplacePage && (
                        <>
                          <button
                            className={style.basic_btn}
                            onClick={onOpen}
                            data-tooltip-id="orders-basic-history-tooltip"
                          >
                            <LocationIconNew /> {t("orderInfo.ordersInfoBasic.historyButton")}
                          </button>
                          <AppTooltip id="orders-basic-history-tooltip" place="top" positionStrategy="fixed">
                            {t('tooltips.orderHistoryTrackingDocuments')}
                          </AppTooltip>
                        </>
                    )}
                </div>
        </div>
    );
};

export default OrdersInfoBasic;
